import * as React from 'react'
import { connect } from 'react-redux'

import useDidMount from '../../../common/hooks/useDidMount'
import { IRootState } from '../../../common/reducers'
import { hasWindow } from '../../../common/utils/envHelper'
import { IQuery } from '../../../common/utils/location/types'
import { IPageComponent } from '../../../typings/pageComponent'
import { IRouteConfigComponentProps } from '../../../typings/routes'

interface IOwnProps extends IRouteConfigComponentProps<IQuery> {}

interface IStateProps {
  ProxiedComponent: IPageComponent<IOwnProps>
  DefaultComponent: IPageComponent<IOwnProps>
}

type Props = IStateProps & IOwnProps

export type MapStateToPageComponent = (
  state: IRootState
) => IPageComponent<IOwnProps>

const PageExperiment = (props: Props) => {
  const { ProxiedComponent, DefaultComponent, ...proxiedProps } = props
  const didMount = useDidMount()
  if (didMount) {
    return <ProxiedComponent {...proxiedProps} />
  }
  return <DefaultComponent {...proxiedProps} />
}

const pageExperimentContainer = (
  componentsList: Array<IPageComponent<IOwnProps>>,
  mapStateToPageComponent: MapStateToPageComponent
) => {
  const mapStateToProps = (state: IRootState): IStateProps => ({
    ProxiedComponent: mapStateToPageComponent(state),
    DefaultComponent: componentsList[0]
  })

  const PageExperimentContainer: IPageComponent<IOwnProps> = connect<
    IStateProps,
    void,
    IOwnProps,
    IRootState
  >(mapStateToProps)(PageExperiment)

  PageExperimentContainer.loadData = props => {
    if (hasWindow()) {
      const ProxiedComponent = mapStateToPageComponent(props.store.getState())
      if (ProxiedComponent.loadData) {
        return ProxiedComponent.loadData(props)
      } else {
        return Promise.resolve()
      }
    } else {
      return Promise.all(
        componentsList.map(component => {
          return component.loadData ? component.loadData(props) : null
        })
      )
    }
  }

  PageExperimentContainer.onBeforePageView = async ({
    store,
    location,
    routeMatch,
    prevLocation
  }) => {
    const ProxiedComponent = mapStateToPageComponent(store.getState())
    if (ProxiedComponent.onBeforePageView) {
      return ProxiedComponent.onBeforePageView({
        store,
        location,
        routeMatch,
        prevLocation
      })
    }
    return Promise.resolve()
  }

  return PageExperimentContainer
}

export default pageExperimentContainer
